import { gql } from '../__generated__/gql';

gql(`
    fragment ClientBasicInfo on ClientType {
        id
        token
        email
        fullName
    }
`);

export const GET_MEMBERSHIP_PRODUCTS_AND_COMPREHENSIVE_EXAM = gql(`
    query GetMembershipProductsAndComprehensiveExam($locationId: String!) {
        memberships: products(filters: {disabled: false, productType: {id: {exact: 1}}}) {
            id
            name
            salePrice(locationId: $locationId)
        }
        comprehensiveExam: products(filters: {disabled: false, id: {exact: 154}}) {
            id
            name
            salePrice(locationId: $locationId)
        }
    }
`);

export const AUTHORIZE_PHONE = gql(`
    mutation AuthorizePhoneWebooking($phoneNumber: String!) {
        authorizePhone (phoneNumber: $phoneNumber) {
            ok
        }
    }
`);

export const VERIFY_CODE = gql(`
    mutation VerifyCode($phoneNumber: String!, $verificationCode: String!) {
        authorizePhone (phoneNumber: $phoneNumber, verificationCode: $verificationCode) {
            ok
            client {
                ...ClientBasicInfo
                household {
                    id
                    patients {
                        appointments {
                            status
                        }
                        id
                        tier
                        name
                        birthdate
                        species
                        isMixed
                        sex
                        spayedOrNeutered
                        hasDeclaredNoPreviousRecords
                        needsRecords
                        breedLookup {
                            id
                            name
                        }
                        colorLookup {
                            id
                            name
                        }
                    }
                    derivedLocation {
                        id
                        region {
                            id
                            timezone
                        }
                    }
                }
            }
        }
    }
`);

export const CREATE_CLIENT = gql(`
    mutation CreateClient($input: ClientInput!) {
        createClient (data: $input) {
            ...ClientBasicInfo
            household {
                id
                derivedLocation {
                    id
                    region {
                        id
                        timezone
                    }
                }
            }
        }
    }
`);

export const PATCH_CLIENT = gql(`
    mutation PatchClient($input: ClientInputPartial!) {
        patchClient(data: $input) {
            id
        }
    }
`);

export const CREATE_CREDIT_CARD = gql(`
    mutation CreateCreditCard($input: CreditCardInput!) {
        createCreditCard(data: $input) {
            id
        }
    }
`);

export const CREATE_APPOINTMENT = gql(`
    mutation CreateAppointment($input: AppointmentInput!) {
        createAppointment(data: $input) {
            id
            start
            end
            location {
                name
                image { url }
                address
                city
                state
                zipcode
                region {
                    id
                    timezone
                }
                phone
                visitorInformation
                latitude
                longitude
            }
            staff {
                name,
                firstName,
                lastName,
            }
            reasonForVisitDescription
            dynamicText {
                changeOfPlansText
                dayOfVisitInstructions
            }
        }
    }
`);
